export const firebaseErrorLabels = new Map([
  ['auth/email-already-in-use', 'Email address is already in use.'],
  ['auth/invalid-email', 'Email address is invalid.'],
  ['auth/wrong-password', 'Invalid email or password.'],
  ['auth/too-many-requests', 'Too many requests, try later.'],
  ['auth/user-not-found', 'Invalid email or password.'],
  ['auth/weak-password', 'Password must be at least 6 characters.'],
])
